/**
 * Карта застосунку — ОДНЕ джерело правди про те, як зветься розділ і де він.
 *
 * Навіщо (owner 2026-09-08): AI-підтримка вела людей по застарілій карті. Вона
 * казала «Профіль — кнопка вгорі праворуч», хоча 01.09 профіль переїхав у
 * перший блок звичайним рядком, а вгорі праворуч тепер «Підтримка». Карта
 * жила текстом усередині промпта, тому зміни в інтерфейсі до неї не доїжджали.
 *
 * Тепер так: назви розділів беруться ЗВІДСИ і в застосунку, і в промпті
 * підтримки. `scripts/export_app_map.mjs` вивантажує цей файл у
 * `data/app_map.json` під час збірки, а `services/support_prompt.py` рендерить
 * із нього розділ «Навігація». Перейменував розділ — підтримка дізнається про
 * це тим самим деплоєм.
 */

export interface AppScreen {
  /** Як розділ називається В ІНТЕРФЕЙСІ — дослівно. */
  title: string;
  /** Де його шукати очима людини. */
  where: string;
  /** Кому видно; порожньо — усім. */
  onlyFor?: "paid";
}

export const APP_MAP: AppScreen[] = [
  {
    title: "Підтримка",
    where: "вгорі праворуч на Головній, овальна кнопка навпроти логотипа",
  },
  {
    title: "Колесо фортуни",
    where: "картка під логотипом на Головній",
  },
  {
    title: "Подвоїти приз колеса",
    where: "попап виграшу на сторінці колеса, кнопка «Подвоїти до …» — лише одразу після виграшу і раз на місяць; у вікні: підписатись на Instagram inFLOW @inflow.in.ua і надіслати посилання на свою сторінку",
  },
  {
    title: "Отримай тиждень підписки на inFLOW",
    where: "окрема сторінка за посиланням t.me/inflow_chatbot?start=insta (бот надсилає запрошення з кнопкою): підписатись на Instagram засновника @its_yehor і надіслати посилання на свою сторінку",
  },
  {
    title: "Стрічка вакансій",
    where: "перший рядок першого блоку на Головній",
  },
  {
    title: "Збережені вакансії",
    where: "другий рядок першого блоку на Головній",
    onlyFor: "paid",
  },
  {
    title: "Профіль",
    where:
      "останній рядок першого блоку на Головній (сфери, джерела, вакансії чи замовлення, формат роботи, мова вакансій, чорний список слів, день народження, портфоліо, управління підпискою, генерація відповідей)",
  },
  {
    title: "Квести і бонуси",
    where: "другий блок на Головній",
  },
  {
    title: "Реферали",
    where: "другий блок на Головній, під квестами",
  },
  {
    title: "Курс",
    where: "блок «Навчання» на Головній",
  },
  {
    title: "База знань",
    where: "блок «Навчання» на Головній",
  },
  {
    title: "Розмістити вакансію",
    where: "окремий рядок на Головній, безкоштовно",
  },
  {
    title: "MCP від inFLOW",
    where:
      "окрема картка в самому низу Головної, під «Розмістити вакансію»: особисте посилання, щоб підключити inFLOW до ChatGPT, Claude, Cursor та інших ШІ (MCP), і інструкція для кожного; посилання можна перевипустити або вимкнути. Блок «Що вміє MCP від inFLOW»: пошук вакансій за запитом, свіжа стрічка, розбір вакансії, чернетка відгуку, збереження. ШІ бачить вакансії сфер людини і повний текст відкритих, контакти — тільки в застосунку",
  },
];

/** Назва розділу за ключем — щоб інтерфейс і підтримка не розʼїхались. */
export const TITLES = {
  feed: "Стрічка вакансій",
  saved: "Збережені вакансії",
  profile: "Профіль",
  quests: "Квести і бонуси",
  refs: "Реферали",
  mcp: "MCP від inFLOW",
} as const;
